var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconServiceFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.153,
    height: 48.64,
    viewBox: "0 0 55.153 48.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38799",
    "data-name": "\\uADF8\\uB8F9 38799",
    transform: "translate(-204.713 -1270.265)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_60",
    "data-name": "\\uC0AC\\uAC01\\uD615 60",
    width: 52.753,
    height: 7.05,
    rx: 3.525,
    transform: "translate(205.913 1291.35)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_61",
    "data-name": "\\uC0AC\\uAC01\\uD615 61",
    d: "M0,0H38.311a0,0,0,0,1,0,0V15.3a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V0A0,0,0,0,1,0,0Z",
    transform: "translate(213.135 1298.4)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19493",
    "data-name": "\\uD328\\uC2A4 19493",
    d: "M9.054,0",
    transform: "translate(228.272 1270.265)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19491",
    "data-name": "\\uD328\\uC2A4 19491",
    d: "M154.013,257.39H137.468v-3.085a8.272,8.272,0,0,1,8.273-8.272h0a8.273,8.273,0,0,1,8.272,8.272Z",
    transform: "translate(96.322 1029.137)",
    fill: "none",
    stroke: "#f09",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_160",
    "data-name": "\\uC120 160",
    x2: 23.256,
    transform: "translate(230.411 1286.989)",
    fill: "none",
    stroke: "#f09",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19492",
    "data-name": "\\uD328\\uC2A4 19492",
    d: "M166.206,241.614v-1.587a1.328,1.328,0,0,0-1.327-1.328h0a1.328,1.328,0,0,0-1.328,1.328v1.587",
    transform: "translate(77.553 1033.602)",
    fill: "#f09"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceFront);
export default __webpack_public_path__ + "static/media/icon-service-front.ae4233651faf9179c534d59fa8300d20.svg";
export { ForwardRef as ReactComponent };